import http from '../utils/http';

const setting={
    /**
     * 获取系统设置
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#209
     * @param {Object} options
     * @param {String} options.fileType 素材类型
     * @returns Promise
     */
    getConfig(options = {},config = {}) {
        return http.post('/sysconfig/list', options, {
            ...config
        })
    },

    /**
     * 修改系统设置
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#209
     * @param {Object} options
     * @returns Promise
     */
    updateConfig(options,config = {}) {
        return http.post('/sysconfig/batchupdate', options, {
            ...config
        })
    },

    /**
     * 获取操作日志
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#209
     * @param {Object} options
     * @returns Promise
     */
    getLog(options = {},config = {}) {
        return http.post('/operationLog/list', options, {
            ...config
        })
    },

    /**
     * 获取故障类型
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#209
     * @param {Object} options
     * @returns Promise
     */
    // getFault() {
    //     return http.post('/breakdown/breakdownTypeList')
    // },

    /**
     * 增加故障类型
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#209
     * @param {Object} options
     * @returns Promise
     */
    // addFault(options ,config = {}) {
    //     return http.post('/breakdown/addBreakdownType',options, {
    //         ...config
    //     })
    // },

    /**
     * 增加故障类型
     * http://112.74.57.123:9101/workspace/myWorkspace.do?projectId=10#209
     * @param {Object} options
     * @returns Promise
     */
    // delFault(options ,config = {}){
    //     return http.post('/breakdown/deleteBreakdownType',options, {
    //         ...config,
    //         showLoading:'删除中...',
    //     })
    // },
}
export default setting;
